exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-outlet {\n  margin-top: 60px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main